import { useEffect, useState } from 'react';
import { Box, useMediaQuery } from '@mui/material';
import useIsProduction from '@/DesignSystem/hooks/useIsProduction';
import useIsUserPremium from '@/DesignSystem/hooks/useIsUserPremium';

const BottomFixedAd = () => {
    const isPremium = useIsUserPremium();
    const isProduction = useIsProduction();
    const isDownTablet = useMediaQuery('(max-width: 1024px)');
    const [isClient, setIsClient] = useState(false);

    useEffect(() => {
        setIsClient(true);
    }, []);

    // ⚠️ TEMPORAL: Permitir en development para testing
    // if (!isClient || isPremium || !isProduction || !isDownTablet) return null;

    if (!isClient || isPremium || !isDownTablet || !isProduction) return null;

    return (
        <Box
            sx={{
                height: 50,
                position: 'fixed',
                bottom: 60,
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                overflow: 'hidden',
                zIndex: 1301,
            }}
        >
            <div id="HB_Footer_Close_hbagency_space_211558">
                <div id="HB_CLOSE_hbagency_space_211558"></div>
                <div id="HB_OUTER_hbagency_space_211558">
                    <div id="hbagency_space_211558"></div>
                </div>
            </div>
        </Box>
    );
};

export default BottomFixedAd;
